import { render, staticRenderFns } from "./materialItem.vue?vue&type=template&id=a08c6f86&scoped=true&"
import script from "./materialItem.vue?vue&type=script&lang=js&"
export * from "./materialItem.vue?vue&type=script&lang=js&"
import style0 from "./materialItem.vue?vue&type=style&index=0&id=a08c6f86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08c6f86",
  null
  
)

export default component.exports